var _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGalleryArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.70711,
    y1: 12.2929,
    x2: 13.0208,
    y2: 23.6066,
    stroke: "#0037A6",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.999985,
    y1: 13,
    x2: 12.3137,
    y2: 1.68628,
    stroke: "#0037A6",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGalleryArrowLeft);
export default __webpack_public_path__ + "static/media/icon_gallery_arrow_left.189d5a8f520afb9b4e26c65ac2cade87.svg";
export { ForwardRef as ReactComponent };